import { render, staticRenderFns } from "./ExtraReviewOperation.vue?vue&type=template&id=fa0b08d2&scoped=true&"
import script from "./ExtraReviewOperation.vue?vue&type=script&lang=js&"
export * from "./ExtraReviewOperation.vue?vue&type=script&lang=js&"
import style0 from "./ExtraReviewOperation.vue?vue&type=style&index=0&id=fa0b08d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0b08d2",
  null
  
)

export default component.exports